// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CTy5","col":"styles_col__z3LMz","actions":"styles_actions__2Z2ph","conflict":"styles_conflict__GM_f6"};